import { applyColorScheme, getStoredColorScheme } from "./colorScheme";

export function initializeTheme(): void {
  applyColorScheme(getStoredColorScheme());
}

if (typeof window !== "undefined") {
  initializeTheme();
}
